import { pipe } from 'rxjs';
import { IEnrollmentAthleteFilter } from 'src/app/core/models/enrollments/atlhete/athlete-enrollment-filter';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';
import { LoadingService } from './loading.service';
import { environment } from 'src/environments/environment';
import { AthleteEnrollmentPostForm } from '../../models/form/athlete-enrollment-post-form';
import { catchError, EMPTY, map, Observable, tap } from 'rxjs';
import { ResponseDto, ResponseWithErrorDto } from '../../models/exceptions/response-dto';
import { AthleteEnrollmentDto } from '../../models/athlete-enrollment-dto';
import { IPage } from '../../models/pagination/page';
import { ListAthleteEnrollmentsDto } from '../../models/list-athlete-enrollments-dto';
import { ICompleteEnrollmentDto } from "../../models/complete-enrollment-dto";
import { AthleteEnrollmentPutForm } from "../../models/form/put/athlete-enrollment-put-form";
import { IUniformDto } from '@models/uniform-dto';
import { IAttachmentDto, IAttachmentValidationDto } from '@models/portal/users/dtos/attachment-dto';
import { EscopeEnrollmentEnum } from '@models/events/enums/scope-enrollment-enum';
import { toParams } from '../../utilities/utility-functions';
import { StatusValidacaoDocumentoEnum } from '@models/form/attachment-post-form';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { IPageable } from '@models/pagination/pageable';
import { FaseGroupFilter } from '@models/competition/step-paramaterization/filters/fase-group-filter';
import { PageRequest } from '@models/pagination/page-request';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentAthleteService {

  private url: string = environment.apiUrl + "/v1/inscricoes";
  private url2: string = environment.apiUrl + "/v1/inscricoes-etapa";

  constructor(private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService) {
  }

  fetchUserUniforms$(usuNrId: number, eveNrId: number): Observable<IUniformDto[]> {
    return this.httpClient.get<ResponseDto<IUniformDto[]>>(`${this.url}/usuarios/${usuNrId}/eventos/${eveNrId}/uniformes`)
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          throw err;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  fetchUserAttachments$(usuNrId: number, eveNrId: number, taeTxEscopoInscricao?: EscopeEnrollmentEnum, incNrId?: number): Observable<IAttachmentDto[]> {
    let params = new HttpParams();
    // if (incNrId && usuNrId) params = params.set('incNrId', incNrId);
    // if (!incNrId && usuNrId) params = params.set('usuNrId', usuNrId);
    if (incNrId) params = params.set('incNrId', incNrId);
    if (usuNrId) params = params.set('usuNrId', usuNrId);
    if (taeTxEscopoInscricao) params = params.set('taeTxEscopoInscricao', taeTxEscopoInscricao);

    return this.httpClient.get<ResponseDto<IAttachmentDto[]>>(`${this.url}/usuarios/eventos/${eveNrId}/anexos`, { params })
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          throw err;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }
  fetchUserAttachmentsValidated$(eveNrId: number, usuNrId:number, taeTxEscopoInscricao: EscopeEnrollmentEnum, incNrId?: number, ueaStatusValidacao?: StatusValidacaoDocumentoEnum): Observable<IAttachmentValidationDto[]> {
    let params = new HttpParams()
    if(taeTxEscopoInscricao) params = params.set('usuNrId',usuNrId)
    if (incNrId) params = params.set('incNrId', incNrId);
    if(taeTxEscopoInscricao) params = params.set('taeTxEscopoInscricao',taeTxEscopoInscricao)
    if(ueaStatusValidacao) params = params.set('ueaStatusValidacao',ueaStatusValidacao)
    //console.log(params);

    //toParams({taeTxEscopoInscricao, ueaStatusValidacao})
    return this.httpClient.get<ResponseDto<IAttachmentValidationDto[]>>(`${this.url}/pendencias/${eveNrId}`, { params })
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          throw err;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  public postAthleteEnrollment(form: AthleteEnrollmentPostForm): Observable<AthleteEnrollmentDto[]> {
    return this.httpClient.post<ResponseDto<AthleteEnrollmentDto[]>>(this.url, form)
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          throw err;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  public putAthleteEnrollment(incNrId: number, form: AthleteEnrollmentPutForm): Observable<AthleteEnrollmentDto> {
    return this.httpClient.put<ResponseDto<AthleteEnrollmentDto>>(this.url.concat(`/${incNrId}`), form)
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          throw err;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  public findCompleteById(incNrId: number): Observable<ICompleteEnrollmentDto> {
    return this.httpClient.get<ResponseDto<ICompleteEnrollmentDto>>(this.url.concat(`/${incNrId}/completa`)).pipe(
      tap(event => { console.log(event); this.loadingService.deactivate(); }),
      map(response => response.response),
      catchError(err => {
        this.messageErrorResolver.resolveMessage(err);
        this.loadingService.deactivate();
        return EMPTY;
      }),
    );
  }

  public checkIfCategoryNeedsAdditionalData(catNrId: number): Observable<boolean> {
    return this.httpClient.get<ResponseDto<boolean>>(this.url.concat(`/categoria/${catNrId}/dados-adicionais`)).pipe(
      map(response => response.response),
      catchError(err => {
        this.messageErrorResolver.resolveMessage(err);
        this.loadingService.deactivate();
        return EMPTY;
      }),
    );
  }

  public findAllAthleteEnrollments(filter?: IEnrollmentAthleteFilter, page?: number, size?: number): Observable<IPage<ListAthleteEnrollmentsDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    if (filter?.eveNrId) params = params.set("eveNrId", filter.eveNrId);
    if (filter?.incTxResumo) params = params.set("incTxResumo", filter.incTxResumo);
    if (filter?.fedNrId) params = params.set("fedNrId", filter.fedNrId);
    if (filter?.insNrId) params = params.set("insNrId", filter.insNrId);
    if (filter?.eveTxTipo) params = params.set("eveTxTipo", filter.eveTxTipo);
    if (filter?.usuTxDocumento) params = params.set("usuTxDocumento", filter.usuTxDocumento);
    if (filter?.usuTxNomeParticipante) params = params.set("usuTxNomeParticipante", filter.usuTxNomeParticipante);
    if (filter?.naipe) params = params.set("naipe", filter.naipe);
    if (filter?.bloNrId) params = params.set("bloNrId", filter.bloNrId);
    if (filter?.comNrId) params = params.set("comNrId", filter.comNrId);
    if (filter?.catNrId) params = params.set("catNrId", filter.catNrId);
    if (filter?.espNrId) params = params.set("espNrId", filter.espNrId);
    //TODO: implementar to params e extractResponse
    return this.httpClient.get<ResponseDto<IPage<ListAthleteEnrollmentsDto>>>(this.url, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public deleteAthleteEnrollment(eventId: number, athleteEnrollmentId: number) {
    return this.httpClient.delete(environment.apiUrl + `/v1/eventos/${eventId}/inscricoes/${athleteEnrollmentId}`)
      .pipe(
        catchError(err => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        }),
      );
  }

  public getAtlheltesWithoutStep(filter: IEnrollmentAthleteFilter, pageable: IPageable): Observable<IPage<ListAthleteEnrollmentsDto>>{
    const params = toParams(filter, pageable);
    return this.httpClient.get<ResponseDto<IPage<ListAthleteEnrollmentsDto>>>(this.url+'/sem-etapa', { params }).pipe(extractResponse())

  }

  public getAtletesByFaseEhClash(filter:FaseGroupFilter,page:PageRequest):Observable<IPage<ListAthleteEnrollmentsDto>>{

    const params = toParams(filter,page);
    return this.httpClient.get<ResponseDto<IPage<ListAthleteEnrollmentsDto>>>(this.url2+'/filtrar-fase-grupo', { params }).pipe(extractResponse())
  }

}
